import React from "react";
import { Modal, Button } from "react-bootstrap";

const ErrorModal = (props) => {
  const onClick = () => {
    window.location.reload();
  };
  return (
    <Modal.Dialog>
      <Modal.Header className="alert-secondary">
        <Modal.Title>Error</Modal.Title>
      </Modal.Header>
      <Modal.Body>Error loading data. Please try again.</Modal.Body>
      <Modal.Footer>
        <Button variant="primary" className="d-block mx-auto" onClick={onClick}>
          Reload Page
        </Button>
      </Modal.Footer>
    </Modal.Dialog>
  );
};

export default ErrorModal;
